/**
 * useUserType — Hook che determina il tipo di utente MSSP autenticato.
 *
 * Chiama GET /api/mssp/mssp/my_info/ e restituisce:
 *   - userType: 'mssp' | 'reseller' | 'partner' | 'whitelabel' | null
 *   - isTecnico: true se tipo_mssp === 'mssp' o 'whitelabel'
 *   - isReseller: true se tipo_mssp === 'reseller'
 *   - isPartner: true se tipo_mssp === 'partner'
 *   - msspInfo: oggetto completo restituito dall'API
 *   - loading: true durante il fetch
 */
import { useMemo } from 'react';
import useGet from './useGet';
import API_ENDPOINTS from '../Config/api';

export default function useUserType() {
  const { fetchedData: msspInfo, loading, error } = useGet(API_ENDPOINTS.myInfoMSSP);

  const result = useMemo(() => {
    const tipo = msspInfo?.tipo_mssp || null;
    return {
      userType: tipo,
      isTecnico: tipo === 'mssp' || tipo === 'whitelabel',
      isReseller: tipo === 'reseller',
      isPartner: tipo === 'partner',
      ordiniAbilitati: !!msspInfo?.ordini_abilitati,
      msspInfo: msspInfo || null,
      loading,
      error,
    };
  }, [msspInfo, loading, error]);

  return result;
}
